import React from 'react'
import { objectKeys } from 'ts-extras'

type Props<ItemsType> = {
  searchText: string
  highlightableItems: ItemsType
  children: (props: { highlightableItems: ItemsType }) => React.ReactNode
  matchingElementsClassName?: string
}

function HighlightableContent<ItemsType extends Record<string, string>>({
  searchText,
  highlightableItems,
  children,
  matchingElementsClassName,
}: Props<ItemsType>) {
  const matchedInput = new RegExp(searchText, 'gi')

  function highlightMatchingText(text: string) {
    return text.replace(matchedInput, (match) => {
      return `<mark class="HighlightableContent__match ${matchingElementsClassName}" style="border-radius: 2px">${match}</mark>`
    })
  }

  const highlightedItems: Partial<Record<keyof ItemsType, string>> = {}

  objectKeys(highlightableItems).forEach((key) => {
    // TODO: Find a way to avoid the cast here
    const item = highlightableItems[key] as string
    highlightedItems[key] =
      searchText.length > 2 ? highlightMatchingText(item) : item
  })

  return <>{children({ highlightableItems: highlightedItems as ItemsType })}</>
}

export default HighlightableContent
